<div class="title-components title-subtitle">
  <h1>Compartir carpeta:</h1>
  <h2>{{ Folder_Selected.Name }}</h2>
</div>

<div class="Options-Menu">
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-shield-halved"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Herencia de permisos {{ Check_Inheritance() }}</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons Switch">
          <div (click)="EnabledOrDisabledIn()" class="Input-Switch">
            <input
              [(ngModel)]="Folder_Selected.Inheritance"
              [disabled]="true"
              type="checkbox"
              name=""
              id="Inheritance_Check"
            />
            <label for="Inheritance_Check"></label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-user-cog"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Herencia de grupos aprobadores {{ Check_InheritanceGA() }}</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons Switch">
          <div (click)="EnabledOrDisabledInGA()" class="Input-Switch">
            <input
              [(ngModel)]="Folder_Selected.InheritanceGA"
              [disabled]="true"
              type="checkbox"
              name=""
              id="Inheritance_CheckGA"
            />
            <label for="Inheritance_CheckGA"></label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-shield-halved"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Flujo opcional {{ Check_Optional_Approvers() }}</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons Switch">
          <div (click)="En_Or_Dis_Optional_Approvers()" class="Input-Switch">
            <input
              [(ngModel)]="Folder_Selected.Optional_Approvers"
              [disabled]="true"
              type="checkbox"
              name=""
              id="Optional_Approvers_Check"
            />
            <label for="Optional_Approvers_Check"></label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- SECCIÓN OCR: Solo mostrar switch si NO es carpeta raíz -->
  <div *ngIf="Folder_Selected.ID_Folder_Top > 0" class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-barcode"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Heredar configuración RegEx Folio {{ ocrInheritance ? 'Activa' : 'Inactiva' }}</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons Switch">
          <div class="Input-Switch">
            <input
              [(ngModel)]="ocrInheritance"
              type="checkbox"
              id="OCR_Inheritance_Check"
            />
            <label for="OCR_Inheritance_Check"></label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Input de RegEx: Se muestra si NO se hereda O si es carpeta raíz -->
  <div *ngIf="!ocrInheritance || Folder_Selected.ID_Folder_Top <= 0" class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-barcode"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>{{ Folder_Selected.ID_Folder_Top <= 0 ? 'Configuración RegEx Folio (Raíz)' : 'Personalizar RegEx Folio' }}</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="inputText">
          <input 
            type="text" 
            [(ngModel)]="Folder_Selected.OCR_Regex"
            placeholder="Ej: MFP-(\d+)" 
          >
        </div>
      </div>
    </div>
  </div>

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Opciones de carpeta</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <!---================= CONTAINER RELOAD PAGE =================--->
        <div class="Container-Buttons">
          <div (click)="Reload_Page()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </div>
          <div
            (click)="SaveChangesApproversGroups()"
            class="Btn-Option button-square Add"
          >
            <span class="Tool-Tip">Guardar Cambios</span>
            <i class="fas fa-save"></i>
          </div>
          <div
            routerLink="/Dashboard/FIN/FMLibraryFIN/em"
            class="Btn-Option button-square"
          >
            <span class="Tool-Tip">regresar</span>
            <i class="fas fa-angle-double-left"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="title-components subtitle">
  <h1>Grupos aprobadores</h1>
</div>

<!--&================== CONTAINER GENERAL LIBRARY ==================&-->
<div class="ConFLCCP">
  <div class="container-card-group">
    <div
      class="content-mock container-global-components"
      (mouseleave)="Unsetgroup()"
    >
      <div class="Content-Top">
        <h2>Configuración de Revisores</h2>
      </div>

      <div class="Content-body-mock">
        <!-- Lista de Revisores Rediseñada -->
        <div
          *ngFor="let group of this.GroupsApprover; let i = index; let last = last"
          class="reviewer-card"
          (mouseenter)="SetInfoGroupApprover(group)"
        >
          <div class="role-label">{{ group.NameRole }}</div>
          
          <div class="group-info">
            <div class="avatar">{{ Format_Initials(group.Name) }}</div>
            <div class="details">
              <div class="name">
                {{ group.ID_G === 0 ? "Sin asignar" : group.Name }}
              </div>
              <div class="status" [style.color]="group.ID_G === 0 ? '#ff9800' : '#4caf50'">
                {{ group.ID_G === 0 ? 'Pendiente' : 'Configurado' }}
              </div>
            </div>
          </div>

          <div class="actions">
            <!-- Switch Requerido/Opcional -->
            <div class="check-wrapper" [title]="group.Required_RG ? 'Requerido' : 'Opcional'">
              <input
                type="checkbox"
                [(ngModel)]="group.Required_RG"
                [disabled]="Folder_Selected.Optional_Approvers === 0"
              />
            </div>

            <!-- Botón Cambiar -->
            <div (click)="ModalGAFIN(i)" class="Btn-Option" title="Cambiar grupo">
              <i class="fas fa-sync-alt"></i>
            </div>

            <!-- Botón Eliminar (solo último) -->
            <div *ngIf="last" (click)="Remove_Last_Approver(i)" class="Btn-Option Delete" title="Eliminar revisor">
              <i class="fas fa-trash-alt"></i>
            </div>

            <!-- Botón Agregar (solo último) -->
            <div *ngIf="last" (click)="Add_New_Approver()" class="Btn-Option Add" title="Agregar revisor">
              <i class="fas fa-plus"></i>
            </div>
          </div>
        </div>

        <!-- Estado Vacío Rediseñado -->
        <div *ngIf="this.GroupsApprover.length === 0" class="empty-state-container">
          <div class="img">
            <img src="./assets/Global/Ilustrations/Not-Group.png" alt="" />
          </div>
          <div class="text">
            Aún no has configurado revisores para esta carpeta. Agrega grupos para definir el flujo de aprobación.
          </div>
          <button (click)="Add_New_Approver()" class="btn-add-reviewer">
            <i class="fas fa-plus"></i>
            <span>Agregar Primer Revisor</span>
          </button>
        </div>
      </div>

      <div class="Container-Progress">
        <div class="ProgressBar"></div>
      </div>
    </div>
    <div class="content-info-group container-global-components">
      <h2>Informacion de grupo</h2>

      <div class="info-group">
        <div
          *ngIf="Group_Hover.ID_G !== 0"
          class="Card__Container--item--Body--Container"
        >
          <div class="Card__Container--item--Body--Container--Square">
            <span>{{ Format_Initials(Group_Hover.Nombre) }}</span>
          </div>

          <div class="Card__Container--item--Body--Container--Info">
            <div class="Card__Container--item--Body--Container--Info--Title">
              {{ Group_Hover.Nombre }}
            </div>

            <div
              class="Card__Container--item--Body--Container--Info--Description"
            >
              {{
                Group_Hover.Descripcion === "" ||
                Group_Hover.Descripcion === null
                  ? "Este grupo aún no tiene descripción, se le recomienda asignarle alguna descripción al grupo para asi identificarlo más rápido"
                  : Group_Hover.Descripcion
              }}
            </div>
          </div>
        </div>

        <div *ngIf="Group_Hover.ID_G === 0" class="not-info">
          <div class="img">
            <img src="../assets/Global/Ilustrations/Not-Group.png" alt="" />
          </div>
          <div class="description">
            Para visualizar la información de un grupo aprobador, desplace el
            cursor sobre cualquier grupo aprobador en el diseño ubicado en el
            lado izquierdo.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR MODIFY GROUPS APPROVERS =====================--->
<section class="Modal-Global GA" id="ModalApproversG">
  <div class="wrapper">
    <div class="Pro-popupMGA popup">
      <div class="Pro-insideMGA popup-inside">
        <div class="Pro-backgroundsMGA backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-contentMGA content">
        <div (click)="ModalGAFIN(1)" class="Btn-Close">
          <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="Content-Top">
          <h2>Seleccionar grupo {{ rolGroupSelected() }}</h2>
          <h4>Seleccione el grupo que desea asignar</h4>
        </div>

        <div class="Content-body">
          <div class="SectionCreateTotal Section-Task">
            <div class="left-CT">
              <div class="Search inputText">
                <i class="fa-solid fa-magnifying-glass"></i
                ><input
                  [(ngModel)]="GrouGA_Filter"
                  type="text"
                  (keyup)="Search_GroupGA()"
                  (keyup)="Search_EnterGA($event)"
                  placeholder="Buscar grupo"
                />
              </div>
            </div>
          </div>

          <div class="Content-Cards">
            <div *ngFor="let Group of All_Groups_Approvers_Copy" class="Card-G">
              <div class="Container-Img">
                <i class="fa-solid fa-users"></i>
              </div>

              <div class="Body-Card">
                <div class="Title">
                  <h3>{{ Group.Nombre }}</h3>
                </div>
                <div class="Description">
                  <p>
                    {{
                      Group.Descripcion === ""
                        ? "sin descripcion"
                        : Group.Descripcion
                    }}
                  </p>
                </div>
                <div class="Button-Card">
                  <div
                    class="btn-icon-text"
                    (click)="ChangeGroupApprover(Group)"
                  >
                    <i class="fa-solid fa-check-double"></i
                    ><span class="text">Seleccionar</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p-paginator
          (onPageChange)="onPageChangeGA($event)"
          [first]="first_GA"
          [rows]="rows_GA"
          [totalRecords]="
            GrouGA_Filter.length < 2
              ? All_Groups_Approvers.length
              : All_Groups_Approvers_Copy_Search.length
          "
          [rowsPerPageOptions]="[5, 10, 15, 20, 30]"
        ></p-paginator>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
